<template>
  <div class="exam">
    <div v-if="exam" class="page">

      <div class="content">
        <Commission
          :me="user"
          :list="commission"/>
        <ExaminedStudent
          v-for="student in startedStudents"
          :getPaper="getPaper"
          :updateStatus="sendStudentStatus"
          :student="student"
          :key="student.id"/>
      </div>

      <div class="sidebar">
        <ExamInfo
          class="examInfo"
          :vertical="true"
          :exam="exam"/>
        <button
          @click="givePapersToAwaitingStudents"
          class="give-papers primary-button">
            {{ $t('exam.action.GIVE_PAPERS') }}
        </button>
        <StudentList
          :getPaper="getPaper"
          :sendPaper="sendPaper"
          :updateStatus="sendStudentStatus"
          :students="students"/>
      </div>

    </div>
  </div>
</template>

<script>
import {
  serverPollingInterval,
  AWAITING_PAPER,
  STARTED,
} from '@/config'

import { mapActions, mapState } from 'vuex'

import ExamInfo from '@/components/room/ExamInfo.vue'
import StudentList from '@/components/room/StudentList.vue'
import ExaminedStudent from '@/components/room/ExaminedStudent.vue'
import Commission from '@/components/commission/Commission.vue'

export default {
  name: 'Exam',
  props: {
    id: String
  },
  components: {
    ExamInfo,
    StudentList,
    ExaminedStudent,
    Commission
  },
  data () {
    return {
      fetcher: null,
      exam: null,
      examPapers: [],
      students: [],
      commission: []
    }
  },
  computed: {
    ...mapState([
      'user'
    ]),
    startedStudents () {
      return this
        .students
        .filter(({ status }) =>
          status === STARTED)
    },
  },
  created () {
    this.$loading.start()

    Promise.all([
      this.getExamInfo(),
      this.fetchExamPapers(this.id)
        .then(papers => {
          this.examPapers = papers
        })
    ])
      .then(() => {
        this.fetcher = setInterval(this.getExamInfo, serverPollingInterval)
      })
      .catch(() => this.$loading.fail())
      .finally(() => this.$loading.done())
  },
  beforeDestroy () {
    clearInterval(this.fetcher)
  },
  destroyed () {
    this.killP2PClient()
  },
  methods: {
    getExamInfo () {
      return Promise.all([
        this.fetchExam(this.id),
        this.fetchExamStudents(this.id),
        this.fetchExamCommission(this.id)
      ])
        .then(([exam, students, commission]) => {
          this.exam = exam
          this.students = students
          this.commission = commission
        })
        .catch(() => {})
    },
    getRandomPaperId () {
      const randomIndex = Math.floor(Math.random() * this.examPapers.length)
      return this.examPapers[randomIndex].id
    },
    getPaper (paperId) {
      return this.examPapers.find(({ id }) => id === paperId)
    },
    sendStudentStatus (params) {
      return this
        .updateStudentStatus(params)
        .then(this.getExamInfo)
    },
    givePapersToAwaitingStudents () {
      this
        .students
        .filter(({ status }) => status === AWAITING_PAPER)
        .map(({ id }) => id)
        .forEach(this.sendPaper)
    },
    sendPaper (studentId) {
      const paperId = this.getRandomPaperId()
      this.sendPaperToStudent({ studentId, paperId })
    },
    ...mapActions([
      'killP2PClient',
      'fetchExam',
      'fetchExamStudents',
      'fetchExamCommission',
      'fetchExamPapers',
      'sendPaperToStudent',
      'updateStudentStatus'
    ])
  },
  watch: {
    '$store.state.loadingError' (error) {
      if (error && this.fetcher) clearInterval(this.fetcher)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/base.scss";

.exam {
.page { @extend %page;
  min-width: 1400px;

  .sidebar {
    .roomInfo {
      margin-bottom: 16px;
    }

    .give-papers {
      margin-bottom: 24px;
    }
  }
}
}
</style>
